import React from 'react';
import { FormattedMessage } from 'react-intl';
export var CookieBanner = function CookieBanner() {
  return React.createElement(FormattedMessage, {
    id: "banner.cookies.message",
    defaultMessage: "This website uses cookies including for advertising, functionality and performance purposes. By continuing to browse the site you are accepting our use of cookies. To find out more about the cookies we use, please read our {privacyPolicyLink} and {cookiesPolicyLink}.",
    values: {
      privacyPolicyLink: React.createElement("a", {
        href: "/privacy"
      }, React.createElement(FormattedMessage, {
        id: "banner.cookies.message.link",
        defaultMessage: "privacy policy"
      })),
      cookiesPolicyLink: React.createElement("a", {
        href: "/privacy#cookies"
      }, React.createElement(FormattedMessage, {
        id: "banner.cookies.message.cookiesLink",
        defaultMessage: "cookie policy"
      }))
    }
  });
};